import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { getLicense } from 'redux/slices/licenseSlice';
import { useDefaultServiceRoute } from '../../common/hooks/useDefaultServiceRoute';
import OAuthTransition from '../../views/OAuthTransition';

const LoadingSetting = () => {
    const navigate = useNavigate();
    const defaultRedirect = useDefaultServiceRoute();
    const license = useSelector(getLicense);
    const { t } = useTranslation();

    useEffect(() => {
        if (license) {
            navigate(defaultRedirect);
        }
    }, [navigate, defaultRedirect, license]);

    return <OAuthTransition message={t('app.loadingSetting')} />;
};

export default LoadingSetting;
